import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/dylanjay/Projects/pretagovhydra/hydraadmin/volto-hydra/examples/hydra-nextjs/src/app/[[...slug]]/PageClient.js");
